import { Injectable } from '@angular/core';
import { ModalController } from 'ionic-angular';
import { safeModalOpts } from '../util/modal-none-transition';

export interface ActivityPickerResult {
  hugID: any;
  hugName: string;
  type?: string;
  hugImage?: string;
  [key: string]: any;
}

export interface ActivityPickerOptions {
  items: any[];
  title?: string;
  multiple?: boolean;
  confirmText?: string;
  searchPlaceholder?: string;
  hugimShlohot?: any[];
}

@Injectable()
export class ActivityPickerService {
  constructor(private modalCtrl: ModalController) {}

  pickOne(
    items: any[],
    title: string = 'בחירת פעילות',
    hugimShlohot: any[] = []
  ): Promise<ActivityPickerResult | null> {
    return this.open({
      items,
      title,
      multiple: false,
      hugimShlohot,
    });
  }

  pickMany(
    items: any[],
    title: string = 'בחירת פעילויות',
    confirmText: string = 'אישור',
    hugimShlohot: any[] = []
  ): Promise<ActivityPickerResult[] | null> {
    return this.open({
      items,
      title,
      multiple: true,
      confirmText,
      hugimShlohot,
    });
  }

  private open(options: ActivityPickerOptions): Promise<any> {
    return new Promise((resolve) => {
      const modal = this.modalCtrl.create(
        'ActivityPickerPage',
        {
          items: options.items || [],
          title: options.title || 'בחירת פעילות',
          multiple: !!options.multiple,
          confirmText: options.confirmText || 'אישור',
          searchPlaceholder: options.searchPlaceholder || 'חיפוש פעילות',
          hugimShlohot: options.hugimShlohot || [],
        },
        safeModalOpts({
          cssClass: 'activity-picker-modal',
        })
      );

      modal.onDidDismiss((result) => {
        if (result == null) {
          resolve(null);
          return;
        }
        resolve(result);
      });

      modal.present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/activity-picker.service.ts